import Swiper from 'swiper';
import { Navigation, Pagination, Thumbs } from 'swiper/modules';

class ProductGallery extends HTMLElement {
  constructor() {
    super();

    this.slider = this.querySelector('[data-gallery-slider]');
    this.thumbnails = this.querySelector('[data-gallery-thumbnails]');

    if (this.thumbnails) {
      // Setups the thumbnails slider
      this.thumbsSwiper = new Swiper(this.thumbnails, {
        spaceBetween: 10,
        slidesPerView: 4,
        centerInsufficientSlides: true,
        watchSlidesProgress: true,
        freeMode: true,
      });
    }

    if (this.slider) {
      // Setups the main slider
      this.swiper = new Swiper(this.slider, {
        modules: [Navigation, Thumbs, Pagination],
        spaceBetween: 10,
        autoHeight: true,
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        thumbs: {
          swiper: this.thumbsSwiper,
        },
        pagination: {
          el: '.swiper-pagination',
          bulletClass: 'w-2 h-2 bg-gray-200 rounded-full transition-all duration-500 ease-in-out',
          bulletActiveClass: '!bg-gray-600 !w-4 3',
        },
        on: {
          init: () => {
            this.thumbnails.classList.remove('opacity-0');
          },
        },
      });
    }
  }
}

customElements.define('product-gallery', ProductGallery);
